import styled, { css } from 'styled-components';
import { Text, Total } from '../SummaryForm/SummaryForm.styles';
import { PrimaryButton } from 'pureUi/Buttons';
import { withDiscountStyles } from 'styles';

export const LodgingSummaryCard = styled.div``;

export const CollapseButton = styled.button`
  float: right;
  display: inline-block;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
`;

export const CollapseHeader = styled(Text)`
  // min-height: 40px;
`;

export const LodgingTotal = styled(Total)`
  margin: 0;
  font-size: 18px !important;
  line-height: auto;
  font-weight: 600 !important;
  text-align: right;

  ${({ ['data-secondary']: secondary }) =>
    secondary &&
    css`
      font-size: 14px;
    `}

  ${({ ['data-discounted']: secondary }) =>
    secondary &&
    css`
      font-size: 14px;
    `}
`;

export const LodgingSummaryTitle = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LodgingTotalWrapper = styled.div``;

export const CollapsibleSection = styled.div``;

export const ButtonSmall = styled(PrimaryButton)`
  font-size: 14px;
  padding: 10px;
  width: 200px;
  height: 40px;
  line-height: 20px;
  flex-grow: 0;
`;

export const MealPlanRatePrice = styled.span`
  ${withDiscountStyles};
`;
